import { HttpParams } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../services/users/users.service";
var credentialsKey = 'currentUser';
var ApplicationService = /** @class */ (function () {
    function ApplicationService(http, userService) {
        this.http = http;
        this.userService = userService;
        this.tabChange = false;
        this.applicationData = new BehaviorSubject(null);
        this.obsApplicationData = this.applicationData.asObservable();
        this.installerFormOnce = false;
        this.permitType = null;
        this.saveAndExit = false;
    }
    ApplicationService.prototype.callApplicationAPI = function (payload) {
        var href = "" + environment.application;
        return this.http.post(href, payload).pipe(tap(function (data) {
            if (data.status === 'success') {
            }
            return data;
        }));
    };
    ApplicationService.prototype.savePayment = function (data) {
        var href = "" + environment.applicationPayment;
        return this.http.post(href, data).pipe(tap(function (data) {
            if (data.status === 'success') {
            }
            return data;
        }));
    };
    // openPdf(data): Observable<any> {
    //   const href = `${environment.downloadPermit}`;
    //   return this.http.post<any>(href, data).pipe(
    //     tap(
    //       (data) => {
    //         if (data.status === 'success') {
    //         }
    //         return data;
    //       }
    //     )
    //   );
    // }
    ApplicationService.prototype.openPdf = function (id) {
        var href = "" + environment.downloadPermit + id + '?downloadType=2&exe=1';
        return this.http.get(href).pipe(map(function (data) {
            if (data.status == 'success') {
                return data.response;
            }
        }));
    };
    ApplicationService.prototype.downloadPermit = function (id, downloadType, exe) {
        var params = new HttpParams();
        params = params.set('downloadType', downloadType);
        params = params.set('exe', exe);
        this.downloadFile = "" + environment.host + ("" + environment.downloadPermit) + ("" + id) + ("" + '?') + params.toString();
        window.open(this.downloadFile);
    };
    ApplicationService.prototype.getApplicationFee = function (query) {
        var href = "" + environment.getApplicationFee;
        return this.http.get(href, { params: query }).pipe(tap(function (data) {
            if (data.status === 'success') {
                return data;
            }
            return data;
        }));
    };
    ApplicationService.prototype.searchAddress = function (searchQuery) {
        var href = environment['searchAddress'];
        return this.http.get(href, { params: searchQuery }).pipe(map(function (data) {
            if (data.status == 'success') {
                return data.response;
            }
        }));
    };
    ApplicationService.prototype.setTabChange = function (val) {
        this.tabChange = val;
    };
    ApplicationService.prototype.getTabChange = function () {
        return this.tabChange;
    };
    ApplicationService.prototype.setInstallerFormRouteOnce = function (val) {
        this.installerFormOnce = val;
    };
    ApplicationService.prototype.getInstallerFormRouteOnce = function () {
        return this.installerFormOnce;
    };
    ApplicationService.prototype.setPermitType = function (val) {
        this.permitType = val;
    };
    ApplicationService.prototype.getPermitType = function () {
        return this.permitType;
    };
    ApplicationService.prototype.setSaveAndExit = function (val) {
        this.saveAndExit = val;
    };
    ApplicationService.prototype.getSaveAndExit = function () {
        return this.saveAndExit;
    };
    ApplicationService.prototype.setWhatFormData = function (obj) {
        this.whatFormData = obj;
    };
    ApplicationService.prototype.getWhatFormData = function () {
        return this.whatFormData;
    };
    ApplicationService.prototype.setBurglarInstallerForm = function (obj) {
        this.burglarInstallerFormData = obj;
    };
    ApplicationService.prototype.getBurglarInstallerForm = function () {
        return this.burglarInstallerFormData;
    };
    ApplicationService.prototype.setFireInstallerForm = function (obj) {
        this.fireInstallerFormData = obj;
    };
    ApplicationService.prototype.getFireInstallerForm = function () {
        return this.fireInstallerFormData;
    };
    ApplicationService.prototype.verifyCSRFToken = function (tokenQuery) {
        var _this = this;
        var href = "" + environment.verifyCSRFToken;
        return this.http.get(href, { params: tokenQuery }).pipe(map(function (data) {
            if (data.status === 'success') {
                var storage = localStorage;
                storage.setItem(credentialsKey, JSON.stringify(data.response));
                _this.userService.userDetails.next(data.response);
                return data.response;
            }
        }));
    };
    ApplicationService.prototype.saveWithoutpayment = function (payload) {
        var href = "" + environment.saveWithoutpayment;
        return this.http.post(href, payload).pipe(tap(function (data) {
            if (data.status === 'success') {
            }
            return data;
        }));
    };
    ApplicationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ApplicationService_Factory() { return new ApplicationService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.UsersService)); }, token: ApplicationService, providedIn: "root" });
    return ApplicationService;
}());
export { ApplicationService };
